import React, { useMemo } from 'react';
import './css/Anchor.css';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import AnchorStore from '../../../store/AnchorStore';

import GalleriesAndVideosCountSection from './GalleriesAndVideosCountSection';


const SPECIAL_GUEST_ANCHOR_ID = 80;
const NAKED_NEWS_LIVE_ANCHOR_ID = 241;


const Anchor = observer((props) => {
  const {
    anchor,
    isBroadcasting,
    isWhitelisted,
    isGuestHomePage,
    isAnchorsPage,
    mediaTotals,
    useAnchorPageFormat,
  } = props;

  const anchorImage = useMemo(() => {
    if (isAnchorsPage && anchor?.anchorsPageImage) {
      return anchor?.anchorsPageImage;
    }

    return anchor?.biopic;
  }, [isAnchorsPage, anchor]);

  const anchorIsBroadcasting = useMemo(
    () => isBroadcasting && isWhitelisted && !isGuestHomePage,
    [isBroadcasting, isWhitelisted, isGuestHomePage]
  );

  // Should not show special guest and NNL profiles
  if (
    anchor?.id === SPECIAL_GUEST_ANCHOR_ID ||
    anchor?.id === NAKED_NEWS_LIVE_ANCHOR_ID ||
    anchor?.name?.toLowerCase()?.includes('test')
  ) {
    return null;
  }

  return (
    <div
      className={classnames('text-center', 'ts', 'col-xs-6', {
        'col-md-2': isGuestHomePage || useAnchorPageFormat,
        'col-md-3 col-sm-4': !isGuestHomePage,
      })}
    >
      <div className="thumbnail">
        <Link to={AnchorStore.buildAnchorLink(anchor)}>
          <img
            alt={anchor.name}
            className="img-responsive unblurred"
            loading="lazy"
            src={anchorImage}
          />
        </Link>
        <div className="caption text-center">
          {!useAnchorPageFormat && <p>{anchor.name}</p>}
          {anchorIsBroadcasting && (
            <div className="flex items-center justify-center broadcast-indicator-wrapper">
              <div className="anchor-broadcast-indicator" />
              <h4 className="white">Online Now</h4>
            </div>
          )}
          <GalleriesAndVideosCountSection
            isGuestHomePage={isGuestHomePage}
            mediaCount={mediaTotals}
          />
        </div>
      </div>
      {useAnchorPageFormat && <p className="anchors-name">{anchor.name}</p>}
    </div>
  );
});

export default React.memo(Anchor);

Anchor.propTypes = {
  anchor: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    anchorsPageImage: PropTypes.string,
    biopic: PropTypes.string,
  }).isRequired,
  fanZones: PropTypes.arrayOf(PropTypes.number).isRequired,
  isBroadcasting: PropTypes.bool.isRequired,
  isWhitelisted: PropTypes.bool.isRequired,
  isAnchorsPage: PropTypes.bool,
  isGuestHomePage: PropTypes.bool,
  mediaTotals: PropTypes.shape({
    totalPublicGalleries: PropTypes.number,
    totalPublicVideos: PropTypes.number,
  }),
  useAnchorPageFormat: PropTypes.bool,
};

Anchor.defaultProps = {
  isGuestHomePage: false,
  isAnchorsPage: false,
  mediaTotals: {
    totalPublicGalleries: 0,
    totalPublicVideos: 0,
  },
  useAnchorPageFormat: false,
};
